import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import getObjectsCases from "./cases/get-objects.cases";
import getObjectsLocationsCases from "./cases/get-objects-locations.cases";
import { ObjectsState } from "../entities/interfaces/object-state.interface";
import getObjectDataForMapCases from "./cases/get-object-data-for-map.cases";
import onObjectLocationReportedEventCases from "./cases/on-object-location-reported-event.cases";
import onObjectIconUpdatedEventCases from "./cases/on-object-icon-updated-event.cases";
import { types } from "@vilocnv/allsetra-core";

const initialState: ObjectsState = {
  objects: [],
  isLoadingObjects: false,
  isLoadingObjectDetail: false,
  markers: [],
  objectFilters: {
    groups: [],
    objectTypes: [],
    keyId: []
  },
  selectedObject: undefined
};

const objectsSlice = createSlice({
  name: "objects/v2",
  initialState,
  reducers: {
    clearSelectedObject: (state) => {
      state.selectedObject = undefined;
    },
    setSelectedObject: (state, action: PayloadAction<{ uniqueId: string }>) => {
      const { uniqueId } = action.payload;
      const object = state.objects.find((o) => o.uniqueId === uniqueId);
      state.selectedObject = object;
    },
    setObjectFilters: (state, action: PayloadAction<types.IMapFilter>) => {
      state.objectFilters = action.payload;
    }
  },
  extraReducers: (builder) => {
    getObjectsCases(builder);
    getObjectsLocationsCases(builder);
    getObjectDataForMapCases(builder);
    onObjectLocationReportedEventCases(builder);
    onObjectIconUpdatedEventCases(builder);
  }
});

export default objectsSlice.reducer;

export const { clearSelectedObject, setSelectedObject, setObjectFilters } =
  objectsSlice.actions;
